import { Autocomplete, Checkbox, StyledEngineProvider, TextField } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react"
import { callSP } from "../../../../setup/axios/AxiosCallSP";
import { LunchGrid } from "../../../utils/lunchGrid/LunchGrid";
import { backService, getOrderHeaderHorizontal, getOrderRowHorizontal, nextService, orderDataRow } from "./serviceMinutaHorizontal/serviceMinutaHorizontal";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { HeadLunchGrid } from "../../../utils/lunchGrid/HeadLunchGrid";
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import * as contract from '../../redux/ContractRedux'
import { AlertModal, AlertModalProps } from "../../../utils/modal/AlertModal";
import { Loading } from '../../../utils/loadingR/Loading'

const MinutaHorizontal: FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const [recetasbyContrato, setRecetasbyContrato] = useState<any[]>()
    const [dataHeader, setDataHeader] = useState<any>([]);
    const [dataHeaderInit, setDataHeaderInit] = useState<any>([]);
    const [rowLunchGrid, setRowLunchGrid] = useState<any>([])
    const [columnModal, setColumnModald] = useState<any>([])
    const [dataRow, setDataRow] = useState<any>([]);
    const [structureSelected, setstructureSelected] = useState<any>([])
    const [grupoEstructura, setGrupoExtructura] = useState<any>([])
    const [leyend, setLeyend] = useState<boolean>(true)
    const [color, setColor] = useState<boolean>(false)
    const [icono, setIcono] = useState<boolean>(false)
    const [normal, setNormal] = useState<boolean>(false)
    const [precio, setPrecio] = useState<boolean>(false)
    const [colorSelected, setColorSelected] = useState<any>([])
    const [alertModal, setAlertModal] = useState<AlertModalProps>();
    const [optionColor] = useState<any>([
        { color: '#DD9255', text: 'color 1' },
        { color: '#FFC107', text: 'color 2' },
        { color: '#AA4035', text: 'color 3' },
        { color: '#35A872', text: 'color 4' }
    ])
    const [params, setParams] = useState<any>()
    const [contratos, setContratos] = useState<any>()
    const [load, setLoad] = useState(false)
    const contrato = '1,2';

    const getDataInit = async () => {
        try {
            const [
                listaIngredientes,
                planillaContrato,
                cabeceraContrato,
                estructuraContrato,
                listaGrupoExtructura
            ] = await Promise.all([
                callSP('amd_getIngredientesPlantillaByContrato', [
                    { text: 'contrato', value: contratos }]),
                callSP('amd_getPlantillaByContrato', [
                    { text: 'contrato', value: contratos }]),
                callSP('amd_getCabeceraPlantillaByContrato', [
                    { text: 'contrato', value: contratos }]),
                callSP('amd_getEstructuraPlantillaByContrato', [
                    { text: 'contrato', value: contratos }]),
                callSP('amd_getGrupoEstructura', [])
            ])
            setGrupoExtructura(listaGrupoExtructura.data.result);
            setRecetasbyContrato(listaIngredientes.data.result)
            const dataH = getOrderHeaderHorizontal(cabeceraContrato.data.result);
            setDataRow(getOrderRowHorizontal(planillaContrato.data.result, estructuraContrato.data.result))
            const dataHeaderInit: any = [];
            let cont = 0;
            dataH.forEach((item: any) => {
                dataHeaderInit[cont] = []
                item.forEach((item: any, key2: number) => {
                    if (key2 < 8) {
                        dataHeaderInit[cont].push(item);
                    }
                })
                cont++;
            })
            setDataHeaderInit(dataHeaderInit);
            setDataHeader(dataH);
            setLoad(false)
        } catch (error) {
            Promise.reject(error);
        }
    }

    useEffect(() => {
        const state: any = location.state
        if (state?.params) {
            setLoad(true)

            const mapHeader = {
                ceco: uniqByFilter(state?.params.map((e: any) => e.ceco)).join(','),
                cli_nombre: uniqByFilter(state?.params.map((e: any) => e.cli_nombre)).join(','),
                codServicio: uniqByFilter(state?.params.map((e: any) => e.codServicio)).join(','),
                id: uniqByFilter(state?.params.map((e: any) => e.id)).join(','),
                plantilla: uniqByFilter(state?.params.map((e: any) => e.plantilla)).join(','),
                reg_codigo: uniqByFilter(state?.params.map((e: any) => e.reg_codigo)).join(','),
                regimen: uniqByFilter(state?.params.map((e: any) => e.regimen)).join(','),
                servicio: uniqByFilter(state?.params.map((e: any) => e.servicio)).join(','),
                tipo_frecuencia: uniqByFilter(state?.params.map((e: any) => e.tipo_frecuencia)).join(','),
                zon_nombre: uniqByFilter(state?.params.map((e: any) => e.zon_nombre)).join(','),
            }

            dispatch(contract.actions.setInfo(true))
            dispatch(contract.actions.setInfoPlantilla(mapHeader))
            setParams(mapHeader)
            setContratos(state?.contratos.join(','))
        }

        return () => {
            dispatch(contract.actions.setInfo(false))
            dispatch(contract.actions.setInfoPlantilla(undefined))
        }
    }, [])

    useEffect(() => {
        if (params) {
            getDataInit()
        }
    }, [params])

    let cont = 0
    const next = useCallback((position: number) => {
        nextService(dataHeaderInit, position, dataHeader, setDataHeaderInit);
    }, [dataHeaderInit, dataHeader])

    const back = useCallback((position: number) => {
        backService(dataHeaderInit, position, dataHeader, setDataHeaderInit);
    }, [dataHeaderInit, dataHeader])

    function uniqByFilter<T>(array: T[]) {
        return array.filter((value, index) => array.indexOf(value) === index);
    }

    return <>
        <Loading
            open={load}
        />
        <HeadLunchGrid
            showLeyend={leyend}
            getLeyend={() => setLeyend(!leyend)}
            isMinutaHorizontal={true}
            isMinutaVertical={false}
            showExportIcon={true}
            showExportClientIcon={true}
            showExportClientIcon2={true}
            showPrintIcon={true}
            showPrintClientIcon={true}
            getColor={() => {
                setColor(!color);
            }}
            getIcono={() => {
                setIcono(!icono);
            }}
            getNormal={() => {
                setNormal(!normal);
            }}
            getPrecio={() => {
                setPrecio(!precio);
            }}
            precio={precio}
            icono={icono}
            normal={normal}
            color={color}
            onSave={function (): void {
                throw new Error("Function not implemented.");
            }} />
        <StyledEngineProvider injectFirst>
            <div style={{ display: 'flex' }}>
                <Autocomplete
                    id="checkboxes-tags-demo"
                    multiple
                    onChange={(event, value) => setstructureSelected(value.map((item: any) => item.id_grupo_estructura))}
                    options={grupoEstructura}
                    isOptionEqualToValue={(option, value) => option.tipo_estructura === value.tipo_estructura}
                    getOptionLabel={(option: any) => option.tipo_estructura}
                    style={{ width: '50%' }}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.tipo_estructura}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField {...params} label="Selección de estructura" placeholder="Estructuras" />
                    )}
                />
                <Autocomplete
                    id='checkboxes-tags-demo2'
                    multiple
                    onChange={(event, value) =>
                        setColorSelected(value.map((item: any) => item.color))
                    }
                    disabled={!color}
                    options={optionColor}
                    getOptionLabel={(option: any) => option.text}
                    style={{ width: '50%' }}
                    renderOption={(props, option, { selected }) => {
                        return (
                            <li {...props} style={{ backgroundColor: option.color }}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.text}
                            </li>
                        )
                    }
                    }
                    renderInput={(params) => (
                        <TextField {...params}
                            onClick={() => {
                                if (!color) {
                                    const alert: AlertModalProps = {
                                        message: "Debe habilitar la opción color",
                                        title: "Alerta",
                                        saveName: "Aceptar",
                                        showClose: false
                                    }
                                    setAlertModal(alert);
                                }
                            }}
                            label='Seleccione color' placeholder='Color' />
                    )}
                />
            </div>
        </StyledEngineProvider>
        {dataHeaderInit?.map((item: any, key: number) => {
            const dr = orderDataRow(item, dataRow[cont], structureSelected);
            cont++;
            return (
                <LunchGrid
                    tableId={"MinutaVertical" + key}
                    nameFile={"Minuta Vertical" + key}
                    isPagination={true}
                    isMinutaVertical={false}
                    isMinutaHorizontal={true}
                    precio={precio}
                    colorSelected={colorSelected}
                    icono={icono}
                    normal={normal}
                    color={color}
                    key={key}
                    openModal={(row, colum, numRow) => {
                        if (row.alertaRecetaFija) {
                            const alert: AlertModalProps = {
                                message: "No se puede editar las recetas fijas",
                                title: "Alerta",
                                saveName: "Aceptar",
                                showClose: false
                            }
                            setAlertModal(alert);
                            return
                        }
                    }}
                    isHeader={false}
                    column={item}
                    rows={dr}
                    next={() => { return next(key); }}
                    back={() => { return back(key); }}
                    onSave={function (): void {
                        throw new Error("Function not implemented.");
                    }} />
            )
        })}
        {alertModal?.message !== undefined &&
            <AlertModal
                message={alertModal?.message}
                show={alertModal?.message !== undefined}
                title={alertModal?.title}
                saveName={alertModal?.saveName}
                showClose={alertModal?.showClose}
                close={() => {
                    setAlertModal(undefined)
                }}
                save={() => {
                    setAlertModal(undefined)
                }}
            />
        }
    </>
}
export { MinutaHorizontal }